module.exports = __webpack_public_path__ + "img/box7-bg.3a307e85.png";